module.exports = __webpack_public_path__ + "static/st-1-cbfb4ff286bc03714f83c006c805d4ba.jpg";